/* External */
import { combineReducers } from "redux";

/* Actions */
import { ACTIONS_GET_CONFIGURATION_FROM_AEM } from "./actions";

/* Others */
import { createBaseReducer } from "../../utils";

const initialStateValues = {
  data: {
    lastRequestDate: 0
  },
  error: {}
};

export const configurationAEM = createBaseReducer(ACTIONS_GET_CONFIGURATION_FROM_AEM, "data", initialStateValues);

export default combineReducers({
  configurationAEM
});
